export default __webpack_public_path__ + "images/0x50b7545627a5162f82a992c33b87adc75187b218.png";